<script>
	export default {
		name: 'AuthExecuter',
		data() {
			return {
				new_: {
					username: null,
					email: null,
					phone: null,
					fullName: null,

					group: 'user',

					resetPassword: false,

					chat: { myChat: true },
					contact: { admin: true }
				}
			}
		},
		methods: {
			// cuurent user
			getCurrentUser(param) {
				const self_ = this;
				const user_ = self_.firebase.auth().currentUser;

				if(self_.isEmpty(user_)) { return null }

				if(self_.isEmpty(param)) { return user_ }
				else { return user_[param] }
			},
			// login
			login(email, password){
				const self_ = this;
				return self_.firebase.auth().signInWithEmailAndPassword(email, password)
			},
			loginByCustomToken(customToken){
				const self_ = this;
				self_.firebase.auth().signInWithCustomToken(customToken)
			},
			logout(){
				const self_ = this;
				const router_ = self_.$router;
				router_.push('/logout')
			},
			// sign up
			signUp(email, password, phoneNumber) {
				const self_ = this;

				const body_ = {}
				body_.email = email;
				body_.password = password;
				if(!self_.isEmpty(phoneNumber)) { body_.phoneNumber = phoneNumber }

				return self_.callFunction('authFunction', 'postSignUp', { body: body_ })
			},
			// reset password
			resetPassword(uid, password) {
				const self_ = this;

				const body_ = {
					uid: uid,
					password: password
				}
				return self_.callFunction('authFunction', 'postChangePassword', { body: body_ })
			}
		}
	}
</script>